var map = {
	"./2dmap/fei_xing_qi_zong_sshu.png": "PMQY",
	"./2dmap_eyes/fei_xing_qi_zong_sshu.png": "x4wq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9uhz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/fei_xing_qi_zong_sshu\.png$
// module id = 9uhz
// module chunks = 2